import React from "react";
import { Box } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import type Interaction from "../../../types/interaction/Interaction";

export interface SegmentButtonProps {
  interaction: Interaction;
}

const SegmentButton = ({ interaction }: SegmentButtonProps) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const isChildSegment =
    !!interaction.masterInteractionId &&
    !!interaction.sourceId &&
    interaction.masterInteractionId !== interaction.sourceId;

  // Always reserve the 28x28 slot so action cells line up across rows,
  // regardless of whether this row is a child segment.
  if (!isChildSegment) {
    return (
      <Box
        aria-hidden
        sx={{ width: 28, height: 28, flexShrink: 0, display: "inline-block" }}
      />
    );
  }

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    const next = new URLSearchParams(searchParams);
    next.set("masterInteractionId", interaction.masterInteractionId!);
    setSearchParams(next);
  };

  return (
    <Box
      component="button"
      onClick={handleClick}
      title="View segments"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 28,
        height: 28,
        borderRadius: "6px",
        border: "none",
        background: "none",
        color: "var(--text-tertiary)",
        cursor: "pointer",
        "&:hover": {
          color: "var(--text-primary)",
          backgroundColor: "var(--bg-raised)",
        },
      }}
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ width: 16, height: 16 }}
      >
        <circle cx="6" cy="6" r="3" />
        <circle cx="18" cy="6" r="3" />
        <circle cx="12" cy="18" r="3" />
        <path d="M6 9v2c0 .6.4 1 1 1h10c.6 0 1-.4 1-1V9" />
        <path d="M12 12v3" />
      </svg>
    </Box>
  );
};

export default SegmentButton;
